import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

export const getPost = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.get(id),
  );
